import { RequestFileLoad } from "./request-file-load.model";

export class RefundRequestFile {
    constructor(
        public contract?: string, // Número de contrato
        public userDocument?: string, // Número de documento del usuario
        public idRefundRequest? : string, // El id de la solicitud del reembolso que se genera al guardar, finalizar el proceso
        public refundTypeName? : string, // El nombre del tipo del reembolso
        public numberOfFilesAllowed? : number, // Cantidad de documentos máximos permitidos
        public supportFileType? : string, // Nombre del documento que es tipo de soporte
        public files? : RequestFileLoad[] // Archivo en base 64
    ) 
    {
        this.files = [];
    }

    // Para el archivo de la certificación bancaria los campos de refundTypeName y numberOfFilesAllowed
    // estaran null, sin embargo el campo supportFileType si contendra el título "Certificación Bancaria"  
    // y el objeto file contendra el archivo de la certificación
}


// WEBPACK FOOTER //
// /app/src/app/shared/models/refund-request-file.model.ts